"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SoulModule = require('./SoulModule');

var config = require('../config');
/**
* Subscribe and notify user about happened events
* @extends SoulModule
*/


var Events =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Events, _SoulModule);

  function Events(params) {
    var _this;

    _classCallCheck(this, Events);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Events).call(this, params));
    _this.poolInterval = params.poolInterval || config.defaultPoolInterval;
    _this.eventEmitter = params.eventEmitter; // TODO DRY duplication. Check SoulModule.constructor

    _this.storage = params.storage;
    return _this;
  }

  _createClass(Events, [{
    key: "startPooling",
    value: function startPooling() {
      this.update();
      this.poolSetIntervalRef = setInterval(this.update.bind(this), this.poolInterval);
    }
  }, {
    key: "stopPooling",
    value: function stopPooling() {
      clearInterval(this.poolSetIntervalRef);
      delete this.poolSetIntervalRef;
    }
  }, {
    key: "isPoolingActive",
    value: function isPoolingActive() {
      return this.poolSetIntervalRef != null;
    }
  }, {
    key: "update",
    value: function update() {
      var _this2 = this;

      var lastEventTime = this.storage.get('lastEventTime') || Date.now() / 1000;
      this.api.get('events', {
        since: lastEventTime
      }).then(function (res) {
        res.events.filter(function (_ref) {
          var time = _ref.time;
          return time > lastEventTime;
        }).forEach(function (event) {
          var _event$type = event.type,
              action = _event$type.action,
              object = _event$type.object;

          _this2.eventEmitter.emit("".concat(action, ".").concat(object), event);

          _this2.eventEmitter.emit("".concat(action, "."), event);

          _this2.eventEmitter.emit(".".concat(object), event);

          _this2.eventEmitter.emit('.', event); // emulate 'anyEvent' listeners

        });

        _this2.storage.set('lastEventTime', res.events.map(function (_ref2) {
          var time = _ref2.time;
          return time;
        }).reduce(function (a, b) {
          return Math.max(a, b);
        }, lastEventTime));

        if (res._meta.total > res._meta.limit) {
          _this2.update();
        }
      })["catch"](function (e) {
        return console.log(e);
      });
    }
    /**
    * subscribe
    * @param {Object} params
    * @param {String} params.action
    * @param {String} params.object
    * @param {function} callback
    * @param {boolean} withoutPooling
    * callback will receive event as first argument
    * @soulsdk soul.events.subscribe
    * @example
    * soul.events.subscribe({
    *   action: 'change',
    *   object: 'reaction',
    * }, (event) => {
    *   console.log('event emitted:', event);
    * });
    */

  }, {
    key: "subscribe",
    value: function subscribe(_ref3, callback, withoutPooling) {
      var _ref3$action = _ref3.action,
          action = _ref3$action === void 0 ? '' : _ref3$action,
          _ref3$object = _ref3.object,
          object = _ref3$object === void 0 ? '' : _ref3$object;
      // allow listening different event types, start pooling if not started
      this.eventEmitter.on("".concat(action, ".").concat(object), callback);

      if (!this.isPoolingActive() && !withoutPooling) {
        this.startPooling();
      }
    }
    /**
    * notify about all events
    * @param {function} callback
    * callback will receive event as first argument
    * @soulsdk soul.events.subscribeToAll
    * @example
    * soul.events.subscribeToAll((event) => {
    *   console.log('event emitted:', event);
    * });
    */

  }, {
    key: "subscribeToAll",
    value: function subscribeToAll(callback) {
      this.subscribe({}, callback);
    }
    /**
    * unsubscribe
    * @param {Object} params
    * @param {String} params.action
    * @param {String} params.object
    * @param {function} [callback]
    * @soulsdk soul.events.unsubscribe
    * @example
    * soul.events.unsubscribe({
    *   action: 'change',
    *   object: 'reaction',
    * });
    */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(_ref4, callback) {
      var _ref4$action = _ref4.action,
          action = _ref4$action === void 0 ? '' : _ref4$action,
          _ref4$object = _ref4.object,
          object = _ref4$object === void 0 ? '' : _ref4$object;
      this.eventEmitter.off("".concat(action, ".").concat(object), callback); // TODO WARNING using of 'private' eventemitter3 field ._eventsCount

      if (this.eventEmitter._eventsCount && this.isPoolingActive()) {
        // if have no listeners, stop pooling
        this.stopPooling();
      }
    }
  }]);

  return Events;
}(SoulModule);

module.exports = Events;